import { Step } from 'types/wizard';
import BackArrow from 'components/DesignSystems/buttons/BackArrow';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { WizardStep } from 'components/Wizard/WizardStep';

export default function WizardContent({
  steps,
  activeStep,
  currentStepIndex,
  renderStepComponent,
  handleBackStep,
}: {
  steps: Step[];
  activeStep: Step;
  currentStepIndex: number;
  renderStepComponent: () => React.ReactNode;
  handleBackStep: () => void;
}) {
  return (
    <div className="right-content">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          {currentStepIndex > 0 ? <BackArrow onBack={handleBackStep} /> : null}
          <div className="text-uppercase step">{`Step ${
            activeStep.id
          }/${steps.length}`}</div>
        </div>

        <button className="button button--link disabled">
          <SharedIcon iconName="help" classes="me-2" />
          Need Help?
        </button>
      </div>

      <WizardStep
        pageTitle={activeStep.pageTitle}
        pageSubTitle={activeStep.pageSubTitle}
      >
        {renderStepComponent()}
      </WizardStep>
    </div>
  );
}
